import _get from 'lodash/get';

import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import {
  ACTION_LOAD_LAST_PAYOUT__REQUEST,
  ACTION_LOAD_LAST_PAYOUT__SUCCESS,
  ACTION_LOAD_LAST_PAYOUT__FAIL,
} from '../actionTypes/lastPayout';

import { PAYOUT_REQUESTS_SCHEMA } from '../../payout/schemas';


const actionLoadLastPayoutSuccess = payout => ({
  type: ACTION_LOAD_LAST_PAYOUT__SUCCESS,
  payload: { payout },
});

const actionLoadLastPayoutFail = error => ({
  type: ACTION_LOAD_LAST_PAYOUT__FAIL,
  payload: { error },
});

export const actionLoadLastPayoutRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_LAST_PAYOUT__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/payout_request',
      {
        params: {
          limit: 1,
          sortField: 'requestDate',
          sortDirection: 'desc',
        },
      },
      PAYOUT_REQUESTS_SCHEMA
    ).then(
      ({ entities, result }) => {
        let payout = null;
        if (Array.isArray(result.items) && result.items[0]) {
          payout = entities.payoutRequests[result.items[0]];
        }
        dispatch(actionLoadLastPayoutSuccess(payout));
      },
      error => {
        dispatch(actionLoadLastPayoutFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
